import { render, staticRenderFns } from "./customerServiceCenter.vue?vue&type=template&id=208da47a"
var script = {}
import style0 from "./customerServiceCenter.vue?vue&type=style&index=0&id=208da47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports